import {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  Button,
  Box,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { AppContext } from "./../contexts/appContext";
import { workAPI } from "../services/WorkService";
import moment from "moment";

const MailControl = () => {
  const { user } = useContext(AppContext);
  const [search, setSearch] = useState(null);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [fetch, setFetch] = useState(0);
  const [data, setData] = useState([]);
  const [emailLoading, setEmailLoading] = useState(false);
  const searchRef = useRef({ name: "", count: 0 });

  const getData = useCallback(
    async (newPage) => {
      try {
        if (search == searchRef.current.name) {
          searchRef.current.count = searchRef.current.count + 1;
        } else {
          searchRef.current.name = search;
          searchRef.current.count = 1;
        }
        const { status, message } = await workAPI.GetEmail({
          page: newPage || page,
          search,
        });
        if (status == 200 && message?.message instanceof Array) {
          setCount(message?.meta?.count || 0);
          setData(message.message);
        } else throw { message };
      } catch (error) {
        alert(error.message);
      }
    },
    [page, search]
  );

  const maxPage = useMemo(() => {
    return Math.ceil(count / 10);
  }, [count]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (user) {
      getData();
    }
    return () => {
      if (!user) {
        setData([]);
      }
    };
  }, [user, page, fetch]);

  useEffect(() => {
    searchRef.current.name = "";
    searchRef.current.count = 0;
  }, [search]);

  const handleSearch = async () => {
    if (searchRef.current.count < 3) {
      getData(0);
      setPage(0);
    }
  };

  const deleteMail = (values) => {
    try {
      setEmailLoading(true);
      workAPI
        .DeleteEmail({ _id: values.id_work })
        .then((res) => {
          if (res.status == 200) {
            Swal.fire({
              icon: "success",
              confirmButtonColor: "#6ab23a",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switchZ",
              },
              width: "28rem",
              timer: 3000,
            });
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          });
        })
        .finally(() => {
          setFetch((old) => (old += 1));
          setEmailLoading(false);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">${error.message}</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 10000,
      }).then(() => {
        setEmailLoading(false);
      });
    }
  };

  const forceMail = (values) => {
    try {
      setEmailLoading(true);
      workAPI
        .ForceEmail({ _id: values.id_work })
        .then((res) => {
          if (res.status == 200) {
            Swal.fire({
              icon: "success",
              confirmButtonColor: "#6ab23a",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switchZ",
              },
              width: "28rem",
              timer: 3000,
            });
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          });
        })
        .finally(() => {
          setFetch((old) => (old += 1));
          setEmailLoading(false);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#f27474",
        html: `<span class="colorWhite">${error.message}</span>`,
        backdrop: "transparent",
        background: "rgba(0,0,0,.75)",
        customClass: {
          icon: "switch",
        },
        width: "28rem",
        timer: 10000,
      }).then(() => {
        setEmailLoading(false);
      });
    }
  };
  return (
    <>
      <Box className="container-promotion">
        <Typography variant="h5" gutterBottom component="div">
          รายการรอส่ง Email{" "}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={4} style={{ margin: "auto" }}>
            <TextField
              variant="outlined"
              label="ค้นหา"
              style={{ margin: "auto" }}
              color="primary"
              fullWidth
              value={search || ""}
              onChange={(e) => setSearch(e.target.value)}
              onKeyPress={(e) => {
                if (e.charCode == 13) {
                  handleSearch();
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search
                      style={{ cursor: "pointer" }}
                      onClick={handleSearch}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        <TableContainer component={Paper} style={{ marginTop: "10px" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="table-header-promotion">No.</TableCell>
                <TableCell className="table-header-promotion">
                  Subject
                </TableCell>
                <TableCell className="table-header-promotion">Email</TableCell>
                <TableCell className="table-header-promotion">
                  ผู้ใช้งาน
                </TableCell>
                <TableCell className="table-header-promotion">
                  วัน/เวลา
                </TableCell>
                <TableCell className="table-header-promotion"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((res, i) => (
                <TableRow key={res._id} className="table-row-promotion">
                  <TableCell className="table-cell-promotion">
                    {i + 1}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res.subject}
                  </TableCell>
                  <TableCell className="table-cell-promotion mobile-promotion">
                    {res.email}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {res.username}
                  </TableCell>
                  <TableCell className="table-cell-promotion">
                    {moment(res.createdAt)
                      .subtract("m", 15)
                      .format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell className="table-cell-promotion mobile-promotion">
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        margin: "2%",
                        backgroundColor: emailLoading
                          ? "lightgray"
                          : "#ef4444",
                        color: "whitesmoke",
                      }}
                      size="small"
                      disabled={emailLoading}
                      onClick={(e) => {
                        e.preventDefault();
                        deleteMail(res);
                      }}
                    >
                      {!emailLoading ? (
                        "Delete Mail"
                      ) : (
                        <CircularProgress
                          size={24}
                          style={{ color: "rgb(106, 178, 58)" }}
                        />
                      )}
                    </Button>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        margin: "2%",
                        backgroundColor: emailLoading
                          ? "lightgray"
                          : "rgb(91, 184, 70)",
                        color: "whitesmoke",
                      }}
                      size="small"
                      disabled={emailLoading}
                      onClick={(e) => {
                        e.preventDefault();
                        forceMail(res);
                      }}
                    >
                      {!emailLoading ? (
                        "ส่ง Mail ทันที"
                      ) : (
                        <CircularProgress
                          size={24}
                          style={{ color: "rgb(106, 178, 58)" }}
                        />
                      )}
                    </Button>
                    <Link to={`/detail-work/${res.id_work}`}>
                      <Button
                        variant="contained"
                        style={{
                          textTransform: "none",
                          margin: "2%",
                          backgroundColor: emailLoading
                            ? "lightgray"
                            : "rgb(91, 184, 70)",
                          color: "whitesmoke",
                        }}
                        size="small"
                        disabled={emailLoading}
                      >
                        Detail
                      </Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {maxPage > 1 && (
          <TablePagination
            rowsPerPageOptions={[]}
            rowsPerPage={10}
            page={page}
            component="div"
            count={count}
            onChangePage={handleChangePage}
          />
        )}
      </Box>
    </>
  );
};

export default MailControl;
